import { getUserStorageKey } from '@/hooks/campaign/utils/storageUtils';

// Hydrate all session/localStorage values from a draft object
export const hydrateToSession = (draft: any): void => {
  if (!draft) return;

  try {
    // Core
    localStorage.setItem('currentStep', String(draft.currentStep ?? 0));
    localStorage.setItem('campaignName', String(draft.name ?? ''));

    // Selected locations
    const selLoc = Array.isArray(draft.selectedLocations) ? draft.selectedLocations : [];
    const selLocJson = JSON.stringify(selLoc);
    localStorage.setItem(getUserStorageKey('selectedLocations'), selLocJson);
    localStorage.setItem('selectedLocations', selLocJson);

    // Form data
    localStorage.setItem('formData', JSON.stringify(draft.formData || {}));

    // Numbers
    const duration = Number.isFinite(draft.duration) ? draft.duration : 14;
    const computedDevices = selLoc.reduce((sum: number, loc: any) => sum + (loc?.devices || 0), 0);
    const devices = Number.isFinite(draft.devices) && draft.devices > 0 ? draft.devices : computedDevices;
    localStorage.setItem('duration', String(duration));
    localStorage.setItem('devices', String(devices));

    // Dates and budgets - only set if they have actual values
    if (draft.startDate && draft.startDate.trim()) {
      localStorage.setItem('startDate', draft.startDate);
    }
    if (draft.endDate && draft.endDate.trim()) {
      localStorage.setItem('endDate', draft.endDate);
    }
    localStorage.setItem('budgetCalculations', JSON.stringify(draft.budgetCalculations || {}));

    // Creatives
    localStorage.setItem('creativeUrls', JSON.stringify(draft.creativeUrls || []));
    localStorage.setItem('locationCreatives', JSON.stringify(draft.locationCreatives || {}));
    localStorage.setItem('mediaOwnerCreatives', JSON.stringify(draft.mediaOwnerCreatives || {}));

    // Flags
    const useLoc = !!draft.useLocationSpecificCreatives;
    const useMo = !!draft.useMediaOwnerSpecificCreatives;
    localStorage.setItem(getUserStorageKey('useLocationSpecificCreatives'), String(useLoc));
    localStorage.setItem(getUserStorageKey('useMediaOwnerSpecificCreatives'), String(useMo));
    localStorage.setItem('useLocationSpecificCreatives', String(useLoc));
    localStorage.setItem('useMediaOwnerSpecificCreatives', String(useMo));
  } catch (e) {
    console.error('hydrateToSession failed:', e);
  }
};
